import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../hooks/useLanguage';

const Footer = () => {
  const { lang, isRTL } = useLanguage();

  const footerLinks = [
    { name: 'À propos', path: `/${lang}/about` },
    { name: 'FAQ', path: `/${lang}/faq` },
    { name: 'Aide', path: `/${lang}/help` },
    { name: 'Contact', path: `/${lang}/contact` },
    { name: 'Politique de confidentialité', path: `/${lang}/privacy` },
    { name: 'Conditions d\'utilisation', path: `/${lang}/terms` },
  ];

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo et description */}
          <div className="space-y-4">
            <Link to={`/${lang}`} className="flex items-center space-x-2">
              <span className="text-2xl font-black bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
                OSC
              </span>
            </Link>
            <p className="text-gray-300">
              Une solution complète pour gérer votre commerce efficacement.
            </p>
          </div>

          {/* Liens rapides */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className={`space-y-2 ${isRTL ? 'text-right' : 'text-left'}`}>
              {footerLinks.slice(0, 3).map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-300 hover:text-white">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Liens légaux */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Légal</h3>
            <ul className={`space-y-2 ${isRTL ? 'text-right' : 'text-left'}`}>
              {footerLinks.slice(3).map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-gray-300 hover:text-white">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} OSC. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 